import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Base/Icon';
import classNames from 'classnames';

const LibraryVideoListItem = ({ video, isSelected, onToggle }) => {
  return (
    <li className="library-video-list__item">
      <div className="library-video-list__label">
        <div
          className="item-pill__action item-pill__action--medium"
          onClick={() => onToggle(video.id)}
          data-test="checkbox-icon"
        >
          <Icon
            name={isSelected ? 'checkbox-selected' : 'checkbox-unselected'}
            className={classNames({
              icon: true,
              'icon--medium': true,
              'icon--green': isSelected,
            })}
          />
        </div>
        <div className="library-video-list__info">
          <a
            href={`/admin/library_videos/${video.uuid}`}
            className="library-video-list__name"
            target="_blank"
            rel="noopener noreferrer"
          >
            {video.name}
          </a>
          {video.tags?.length > 0 && (
            <div className="library-video-list__tags">
              {video.tags.map((tag, idx) => (
                <span
                  key={idx}
                  className="library-video-list__tag"
                >
                  {tag.label || tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </li>
  );
};

LibraryVideoListItem.propTypes = {
  video: PropTypes.shape({
    id: PropTypes.string.isRequired,
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    tags: PropTypes.array,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default LibraryVideoListItem;
